module.exports = __webpack_public_path__ + "static/backdrop@1.5x-0a910f8497a0580abcb8bad928153153.jpg";